import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/tibia-theme.css';
import { APP_CONFIG } from './config/api';

// Define o título da página dinamicamente
document.title = APP_CONFIG.APP_NAME;

// Atualiza a meta description
const metaDescription = document.querySelector('meta[name="description"]');
if (metaDescription) {
  metaDescription.setAttribute('content', APP_CONFIG.APP_DESCRIPTION);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
